import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Grid } from '@mui/material';
import { useCallback, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion';
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema";
import { HttpLCTC } from "./api/httpLCTC";
import { SeccionNuevoLCTCDatosOperacion } from "./components/SeccionNuevoLCTCDatosOperacion";
import { SeccionNuevoLCTCCuentas } from "./components/SeccionNuevoLCTCNuevoCuentas";
import { OperacionLCTCInsert } from "./types/dto";
import { OperacionLCTCFields } from "./types/fields";
import { FormOperacionLCTC, schemaFormOperacionLCTC } from "./types/types";

interface NuevoSistemaLCTCProps {
    codSistemaPrincipal: number
}

const NuevoSistemaLCTC = ({ codSistemaPrincipal }: NuevoSistemaLCTCProps) => {
    const { submitOperacion } = useSubmitOperacion();

    const formMethods = useForm<FormOperacionLCTC>({
        resolver: zodResolver(schemaFormOperacionLCTC),
        defaultValues: {
            [OperacionLCTCFields.FechaSolicitud]: new Date(),
            [OperacionLCTCFields.CodPais]: codSistemaPrincipal,
            [OperacionLCTCFields.Cuentas]: []
        }
    })

    const handleCrearOperacion = useCallback(
        (data: OperacionLCTCInsert) => {
            submitOperacion(data, {
                apiCall: HttpLCTC.post,
                codSistemaPrincipal,
            });
        },
        [codSistemaPrincipal, submitOperacion]
    );

    const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

    useEffect(() => {
        const onSend = () => formMethods.handleSubmit(data => handleCrearOperacion(data))
        setSendPromise(onSend)
    }, [formMethods, handleCrearOperacion])

    return (
        <Box>
            <Grid container spacing={6}>
                <Grid item xs={12}>
                    <SeccionNuevoLCTCDatosOperacion formMethods={formMethods}
                        codSistemaPrincipal={codSistemaPrincipal}
                        codSistema={codSistema}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SeccionNuevoLCTCCuentas formMethods={formMethods} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default NuevoSistemaLCTC
